/** Query sentinel when a summary/transcription GET fails due to network */
export const VIDEO_HISTORY_NETWORK_ERROR =
  'VIDEO_HISTORY_NETWORK_ERROR' as const;

export const VIDEO_HISTORY_NETWORK_ERROR_DESCRIPTION =
  'The network connection was lost.\nPlease check your connection, and try again later.';
